import React, { useState, useEffect }from 'react';
import axios from 'axios';
import SftGlobalData from '../../library/SftGlobalData';
import 'react-toastify/dist/ReactToastify.css';
import { DataGridPro } from '@mui/x-data-grid-pro';

const LicenceConnectionHistoryForm = (props) =>  {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [searchValue, setSearchValue] = useState("");

    useEffect (()=>{
        try{
            SftGlobalData.post('client&action=fetchHistory', {key: props.api, licence_id: props.licenceId, user: props.username, sftUserId: props.userId}).then(response => {
                setData(response.data);
                setLoading(false);
            });
        } catch(e){
            console.error(e);
        }
    }, [props.api, props.licenceId]);

    const gridWebhookColumns = [
        {
            field: 'user_display',
            headerName: 'User',
            minWidth: 100,
            width: 100,
            align: "left", 
            display: 'flex',
        },   
   

        {
            field: 'hist_type',
            headerName: 'Type',
            minWidth: 100,
            width: 100,
            align: "left", 
            display: 'flex',
        },   

        {
            field: 'hist_action',
            headerName: 'Action',
            minWidth: 100,
            width: 100,
            align: "left", 
            display: 'flex',
        },   

        {
            field: 'licence_id',
            headerName: 'Key ID',
            minWidth: 75,
            maxWidth: 75,
            width: 75,
            align: "left", 
            display: 'flex',
        },   

        {
            field: 'remark',
            headerName: 'remark',
            width: 320,
            align: "left", 
            display: 'flex',
        },   

        {
            field: 'created_at',
            headerName: 'Time',
            minWidth: 160,
            align: "left", 
            display: 'flex',
        },   

      ];

    function DataGrid() {
        return (
          <div className={props.theme} style={{width: props.screenWidth - props.screenWidth/100*10}}>
            <input 
                type="text"
                name="search"
                className={props.theme+"_accent_darker "}
                style={{marginTop: 0 }}
                placeholder={props.t('search')}
                value={searchValue}
                onChange={e => setSearchValue(e.target.value)}
            />
            
            {props.accountId != "0" && <DataGridPro
                className={props.theme}
                columns={gridWebhookColumns}
                rows={data.filter(row => (row.id?.toString()?.match(new RegExp(searchValue, "i")) || row.created_at?.match(new RegExp(searchValue, "i")) || row.licence_id?.toString()?.match(new RegExp(searchValue, "i")) || row.remark?.match(new RegExp(searchValue, "i")) || row.user_display?.match(new RegExp(searchValue, "i")) || row.hist_action?.match(new RegExp(searchValue, "i")) || row.hist_type?.match(new RegExp(searchValue, "i"))))
                .map((row) => {return {
                        id: row.id,
                        hist_type: row.hist_type,
                        licence_id: row.licence_id,
                        remark: row.remark,
                        created_at: row.created_at,
                        hist_action: row.hist_action,
                        is_admin: row.is_admin,
                        user_display: row.user_display
                    }
                })}
                //{...data}
                rowHeight={38}
                style={{height: 500}}
                pagination={true}
                loading={loading}

                />   }       
          </div>
        );
    }


    return (
        <div>
            {DataGrid()}
        </div>
    );
}

export default LicenceConnectionHistoryForm;
